import React from 'react';
import { onScroll } from '@/hooks/paging';
import ThemesFilters from './ThemesFilters';
import ThemeCards from './ThemeCards';
import ThemesPanelContainer from './ThemesPanelContainer';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const ThemesPanelNarrow = ({ category }) => {
  const state = selectors.useThemesPanel({ category });
  const fetchData = events.useFetchThemes(category);

  return (
    <ThemesPanelContainer category={category} className="aridhia-themes-panel-narrow" compact>
      <div className="sticky-panel-header">
        <ThemesFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <ThemeCards
        category={category}
        handleScroll={() => onScroll(fetchData, state)}
        items={state.themes}
        itemsPerRow={1}
        readErrors={state.readErrors}
        readStatus={state.readStatus}
      />
    </ThemesPanelContainer>
  );
};

export default ThemesPanelNarrow;
